import { Modal, ModalWidth } from '@creditsights/styleguide-web';
import { useGlobalModalContext } from '../GlobalModal';

interface NoPermissionsModalProps {
  salesPersonEmail: string;
}

const NoPermissionsModal = ({ salesPersonEmail }: NoPermissionsModalProps): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();

  return (
    <Modal width={ModalWidth.Medium} headerTitle="No Access" onClose={closeModal} open>
      <div>
        User has no permissions or active subscription. Contact your account representative at{' '}
        <a href={`mailto:${salesPersonEmail}`}>{salesPersonEmail}</a>
      </div>
    </Modal>
  );
};

export default NoPermissionsModal;
